<script setup>
const localePath = useLocalePath()
const client = useStrapi()
const { locale } = useI18n()

const { transparentHeader } = defineProps({
  mobile: Boolean,
  transparentHeader: Boolean
})

const {
  data: result,
  status,
  error
} = await useAsyncData(
  'header',
  async () =>
    await client.single('header').find({
      populate: {
        nav: {
          fields: ['label', 'to']
        }
      },
      locale: locale.value
    }),
  {
    watch: [locale]
  }
)

const activeClass = computed(() => {
  return `${transparentHeader ? 'text-stone-50' : 'text-stone-950'}`
})
</script>

<template>
  <nav
    :class="['flex items-center gap-6', { 'flex-col mt-4': mobile }]"
    v-if="status === 'success'"
  >
    <ULink
      v-for="link in result.data?.nav"
      :key="link?.label"
      :class="[
        ' uppercase hover:text-stone-950 font-bold ',
        { 'text-sm': !mobile },
        { 'hover:text-stone-50': transparentHeader }
      ]"
      :active-class="activeClass"
      :inactive-class="transparentHeader ? 'text-stone-400' : 'text-stone-600'"
      :to="localePath(link?.to)"
    >
      {{ link?.label }}
    </ULink>
  </nav>
</template>
